import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import PopUp from 'app/Components/Shared/Popup/PopUp';
import InternalTvContentBlockData from 'app/Models/Content/InternalTvContentBlockData';
import InternalTvContentsItemsBlockData from 'app/Models/Content/InternalTvContentsItemsBlockData';
import classNames from 'classnames';
import React, {useState, useRef} from 'react';
import SwiperCore, {Navigation} from 'swiper';
import 'swiper/components/navigation/navigation.scss';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';
import {Container} from 'reactstrap';
import {getImageProps, ImageProps} from 'app/utilities/ImageProps';
import {NavigationOptions} from 'swiper/types/Components/navigation';

SwiperCore.use([Navigation]);

type PopupData = {
  summary: string;
  image: ImageProps;
  title: string;
};

const InternalTvContentsItemsBlock = ({data, context}: ComponentProps<InternalTvContentsItemsBlockData>) => {
  const [popupData, setPopupData] = useState<PopupData>(null);
  const [showPopUp, setShowPopUp] = useState(false);

  const openPopup = (event, summary: string, image: ImageProps, title: string) => {
    event.preventDefault();
    setPopupData({
      summary,
      image,
      title,
    });
    setShowPopUp(true);
  };

  const toggleArrows = (swiper: SwiperCore) => {
    setTimeout(() => {
      if (swiper.isBeginning && swiper.isEnd) {
        swiper.navigation?.nextEl?.classList.add('hide');
        swiper.navigation?.prevEl?.classList.add('hide');
      } else {
        swiper.navigation?.nextEl?.classList.remove('hide');
        swiper.navigation?.prevEl?.classList.remove('hide');
      }
    });
  };
  const isBig = data.bigImage.value == true;
  return (
    <div
      className={classNames('InternalTvContentsItemsBlock', 'big-image-container', data.isInHeader.value == true ? 'in-header' : 'bottom')}>
      <div className={classNames(data.isInHeader.value == true ? 'in-header' : 'bottom')}>
        <div style={{position: 'relative'}}>
          <Container>
            {data.categoryName.value.length > 0 && (
              <span className='InternalTvContentsItemsBlock__categoryTitle'>{data.categoryName.value}</span>
            )}
          </Container>
          <Swiper
            centerInsufficientSlides
            // simulateTouch={false}
            navigation={{
              nextEl: `.${data.isInHeader.value == true ? 'in-header' : 'bottom'} ${
                isBig ? '.big-internal-swiper' : '.small-internal-swiper'
              }-nextEl`,
              prevEl: `.${data.isInHeader.value == true ? 'in-header' : 'bottom'} ${
                isBig ? '.big-internal-swiper' : '.small-internal-swiper'
              }-prevEl`,
            }}
            className='InternalTvContentsItemsBlock__swiper'
            spaceBetween={20}
            slidesPerView='auto'
            onInit={toggleArrows}
            onResize={toggleArrows}>
            {data.items.expandedValue.map((item: InternalTvContentBlockData, i) => {
              return (
                <SwiperSlide
                  onClick={(e) => {
                    openPopup(e, item.summary.value, getImageProps(item.image, context), item.title.value);
                  }}
                  key={i}>
                  <div className={`InternalTvContentsItemsBlock__swiper__big-image-wrap`}>
                    <Image className={`InternalTvContentsItemsBlock__swiper__big-image-wrap__big-image`}
                      {...getImageProps(item.image, context)} />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div className={`${isBig ? 'big-internal-swiper' : 'small-internal-swiper'}-nextEl`}>
            <Image src={require('./images/left-icon.svg')} />
          </div>
          <div className={`${isBig ? 'big-internal-swiper' : 'small-internal-swiper'}-prevEl`}>
            <Image src={require('./images/right-icon.svg')} />
          </div>
        </div>
      </div>

      <PopUp className={'InternalTvContentsItemsBlock__container-popup'} showPopUp={showPopUp} onClose={() => setShowPopUp(false)}>
        <Image className='InternalTvContentsItemsBlock__container-popup__popup-image' {...popupData?.image} />

        <div className='InternalTvContentsItemsBlock__container-popup__popup-title-and-text'>
          <h4>{popupData?.title}</h4>

          <div dangerouslySetInnerHTML={{__html: popupData?.summary}}></div>
        </div>
      </PopUp>
    </div>
  );
};

export default InternalTvContentsItemsBlock;
